import { motion, useReducedMotion } from "framer-motion";

function fmt(n, currency) {
  if (currency === "INR") return `₹${Math.round(n).toLocaleString("en-IN")}`;
  return `$${Number.isInteger(n) ? n : n.toFixed(2)}`;
}

export default function YearlySavings({ monthly, yearly, currency = "INR", highlight = false }) {
  const reduce = useReducedMotion();
  const m = Number(monthly);
  const y = Number(yearly);
  if (!m || !y) return null;

  const saved = m * 12 - y;
  if (saved <= 0) return null;

  return (
    <div className="mt-2" data-testid="yearly-savings">
      <p className={`text-xs ${highlight ? "text-white/90" : "text-ink/70"}`}>
        <span className="line-through opacity-60">{fmt(m, currency)}/mo</span>{" "}
        <span className="font-bold">{fmt(y / 12, currency)}/mo</span> effective
      </p>

      <div className="mt-1 flex items-end justify-center gap-1">
        <motion.span
          initial={reduce ? false : { scale: 0.6, opacity: 0, rotate: -8 }}
          animate={{ scale: 1, opacity: 1, rotate: -2 }}
          transition={{ type: "spring", stiffness: 380, damping: 14, delay: 0.15 }}
          className={`inline-block rounded-full px-3 py-1 text-[11px] font-bold shadow-sm ${
            highlight ? "bg-white text-hotpink" : "bg-green-100 text-green-700"
          }`}
        >
          <span aria-hidden="true">🎉 </span>
          You save {fmt(saved, currency)} a year
        </motion.span>

        {/* Hand-drawn arrow curling up toward the effective price */}
        <svg
          viewBox="0 0 44 38"
          className={`-mb-1 -ml-1 h-10 w-10 flex-none ${highlight ? "text-white" : "text-green-600"}`}
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <motion.path
            d="M6 34 Q 36 34, 26 8"
            initial={reduce ? false : { pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 0.5, delay: 0.35, ease: "easeOut" }}
          />
          <motion.path
            d="M17 16 L26 5 L35 15"
            initial={reduce ? false : { pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{ duration: 0.2, delay: 0.8 }}
          />
        </svg>
      </div>
    </div>
  );
}